// Local helpers so we don't import tokens that target different sets.
export const HEADER = {
    height: "h-16",
    paddingX: "px-4 md:px-5",
} as const;

export const ICON_BASE = "h-4 w-4";
export const TOUCH = "h-9 md:h-8";
